import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=0410bbb4&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=0410bbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0410bbb4",
  null
  
)

/* custom blocks */
import block0 from "@/locales/order_item.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2F_shared%2FOrder%2FItem%2FOrderItem.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports